import { useDeploymentMode } from "../../../hooks/useDeploymentMode";
import { useTranslation } from "react-i18next";
import { Navigate, useLocation, useSearchParams } from "react-router-dom";
import { PageEmbedProvider } from "../../../components/layout";
import { PageHeader, PageListContainer } from "../../../components/Page";
import {
  defaultSuperAdminSection,
  findSuperAdminSection,
} from "../sections";

function sectionFromPath(pathname: string): string | undefined {
  const match = pathname.match(/^\/super-admin\/([^/]+)/);
  return match?.[1];
}

export default function SuperAdminPortalPage() {
  const { t } = useTranslation();
  const { onPrem } = useDeploymentMode();
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const sectionParam = sectionFromPath(pathname);

  // Old hub links used ?tab=; send them to the path-based menu routes.
  const legacyTab = searchParams.get("tab");
  if (!sectionParam && legacyTab) {
    return <Navigate to={`/super-admin/${legacyTab}`} replace />;
  }

  const sectionKey = sectionParam || defaultSuperAdminSection(onPrem);
  const section = findSuperAdminSection(sectionKey);

  if (!section || (section.saasOnly && onPrem)) {
    return <Navigate to={`/super-admin/${defaultSuperAdminSection(onPrem)}`} replace />;
  }

  return (
    <PageListContainer>
      <PageHeader
        title={t(`superAdmin.tabs.${section.labelKey}`)}
        subtitle={t("superAdmin.subtitle")}
      />
      <PageEmbedProvider>{section.render()}</PageEmbedProvider>
    </PageListContainer>
  );
}
